import React, { useState, useEffect } from 'react';
import PostHeader from '@components/PostHeader';
import PostMobile from '@components/PostMobile';
import '@styles/BlogBody.css';
const Postsalesforce3 = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Add Open Graph meta tags for this specific post
  useEffect(() => {
    const updateMetaTag = (property, content, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let metaTag = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute(attribute, property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };

    const post = {
      title: "Salesforce Service Cloud: Enhancing Customer Support",
      date: "March 1, 2024",
      image: "/assets/FeedItems/BB0DJzYds75JyH9gjyj.svg",
      summary: "Explore the features of Salesforce Service Cloud for enhancing customer support. Learn about case management, knowledge base, and omnichannel support.",
      path: "blog/technology/salesforce/post/postsalesforce3"
    };

    document.title = `${post.title} - Cloud CZR`;
    updateMetaTag('og:title', `${post.title} - Cloud CZR`);
    updateMetaTag('og:description', post.summary);
    updateMetaTag('og:url', window.location.href);
    updateMetaTag('og:type', 'article');
    updateMetaTag('og:image', `${window.location.origin}${process.env.PUBLIC_URL}${post.image}`);
    updateMetaTag('og:image:alt', 'Cloud CZR, Cloudczr, cloudczr.com');
    
    updateMetaTag('description', post.summary, false);
    updateMetaTag('twitter:title', `${post.title} - Cloud CZR`, false);
    updateMetaTag('twitter:description', post.summary, false);
  }, []);

  const post = {
    title: "Salesforce Service Cloud: Enhancing Customer Support",
    date: "March 1, 2024",
    image: "/assets/FeedItems/BB0DJzYds75JyH9gjyj.svg",
    summary: "Explore the features of Salesforce Service Cloud for enhancing customer support. Learn about case management, knowledge base, and omnichannel support.",
    path: "blog/technology/salesforce/post/postsalesforce3"
  };
  return (
    <div>
      {isDesktop ? (
        <PostHeader post={post} config={{ width: '400px', height: '400px' }} />
      ) : (
        <PostMobile post={post} config={{ width: '400px', height: '400px' }} />
      )}
      <div class="body-gold">
        <p>
          Salesforce Service Cloud is a comprehensive customer service platform designed to help businesses deliver exceptional customer support. It provides a range of tools and features to manage customer inquiries, resolve issues, and improve overall customer satisfaction.
        </p>
        <h2>Key Features of Service Cloud</h2>
        <p>
          Service Cloud offers features such as case management, knowledge base, live chat, and omnichannel support. These tools enable customer service teams to efficiently handle customer inquiries and provide timely resolutions.
        </p>
        <h2>Case Management</h2>
        <p>
          Service Cloud's case management feature allows you to track and manage customer issues from start to finish. You can create, assign, and prioritize cases, ensuring that customer inquiries are resolved promptly and effectively.
        </p>
        <h2>Knowledge Base</h2>
        <p>
          The knowledge base feature provides a centralized repository of articles and resources that customers and support agents can access to find answers to common questions. This helps reduce the volume of support inquiries and empowers customers to resolve issues on their own.
        </p>
        <h2>Omnichannel Support</h2>
        <p>
          Service Cloud supports multiple communication channels, including email, phone, chat, and social media. This allows customers to reach out through their preferred channel and ensures a seamless support experience.
        </p>
        <p>
          Salesforce Service Cloud is a powerful platform that can help businesses enhance their customer support operations. By leveraging its comprehensive features and tools, you can deliver exceptional customer service and improve overall customer satisfaction.
        </p>
      </div>
    </div>
  );
};

export default Postsalesforce3;